module.exports = __webpack_public_path__ + "img/register5.9cd903c.png";